import Http from './http'

export default {
	index(filter){
    return Http.get('/tasks', {params: {...filter}})
  },
  indexByModel({model_name, model_id}){
    return Http.get(`/${model_name}/${model_id}/tasks`)
  },

  show(id){
    return Http.get(`/tasks/${id}`)
  },

  create(task){
    return Http.post(`/tasks/`, {
      task: {
        ...task
      }
    })
  },
  update(task){
    return Http.put(`/tasks/${task.id}`, {
      task: {
        ...task
      }
    })
  },

  delete(id){
    return Http.delete(`/tasks/${id}`)
  },
}
